const hasNodeType = (editorState, nodeType, checkCallback)=>editorState.read(()=>{
        const nodesList = Array.from(editorState._nodeMap.values()).filter(({ __type })=>__type === nodeType);
        if (checkCallback) return nodesList.some((node)=>checkCallback(node));
        return !!nodesList.length;
    });
export { hasNodeType };
